import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { getPepActions } from "../../../redux/slices/PepSlice";
import useUserRole from "../../../hooks/useUserRole";
import PepUserActionTable from "./PepUserActionTable";
import Loader from "../../loader/Loader";
import PageLoadingFailNotification from "../../PageLoadingFailNotification/PageLoadingFailNotification";
import NewPepActionModal from "../AddNewPepActionModal";

const PepUserActionComponent = () => {
  const { PepActionList, loading_getPepActions } = useSelector((state) => ({ ...state.pep }));
  const { usersInfos } = useSelector((state) => ({ ...state.userInfos }));
  const { isAdmin, isManager, hasAccessAsDeveloper } = useUserRole();
  const { accounts } = useMsal();
  const [updatePage, setUpdatePage] = useState(false);
  const [actionTablePageIndex, setActionTablePageIndex] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    loadPepActions();
  }, [updatePage]);

  const loadPepActions = useCallback(() => {
    dispatch(getPepActions());
  }, []);

  const filteredPepActions = useMemo(() => {
    const actions = PepActionList?.data ?? [];
    if (isManager && !isAdmin && !hasAccessAsDeveloper) {
      const oid = accounts[0]?.idTokenClaims?.oid;
      const myUserIds = (usersInfos?.data ?? [])
        .filter((u) => u.operatingManagerId === oid)
        .map((u) => u.userId);
      return actions.filter((a) => myUserIds.includes(a.userId));
    }
    return actions;
  }, [PepActionList, usersInfos, isManager, isAdmin, hasAccessAsDeveloper, accounts]);

  return loading_getPepActions ? (
    <Loader />
  ) : PepActionList && PepActionList.data ? (
    <div>
      <div className="d-flex justify-content-end">
        {(isAdmin || isManager || hasAccessAsDeveloper) && (
          <NewPepActionModal updatePage={updatePage} setUpdatePage={setUpdatePage} />
        )}
      </div>
      <div>
        <PepUserActionTable
          pepActions={filteredPepActions}
          onDataReload={(pageIndex) => {
            setActionTablePageIndex(pageIndex);
            loadPepActions();
          }}
          pageIndex={actionTablePageIndex}
        />
      </div>
    </div>
  ) : (
    <PageLoadingFailNotification text="la récupération des données a echoué, veuillez actualiser la page ou vous reconnecter !" />
  );
};

export default PepUserActionComponent;
